// DcvModeToggle.js
import { Button, Stack } from '@mui/material';
import { brandColors } from 'types/colors';

const BTN_HEIGHT = '1rem'; // match your other boxes

/**
 * Props
 * -----
 * dcvChecked : boolean   // if false → greyed‑out & inertUnitTypeToggle
 * onSelect   : function  // called with 'solai' | 'manual'
 */
const HvacUnitSelector = ({ setUnitType, selected }) => {
  const handleSelect = mode => {
    setUnitType(mode);
  };

  return (
    <Stack
      direction="row"
      spacing={1} // gap between buttons
      sx={{
        width: '100%',
        maxWidth: '8.7rem',
        // width: '10rem',
        // border: `1px solid red`,
        justifyContent: 'space-between',
        alignItems: 'center',
      }} // let them share the available row width
    >
      {/* --- AUTO / left button (image) --- */}
      <Button
        onClick={() => handleSelect('AHU')}
        sx={{
          flex: 1,
          minWidth: '65px',
          maxWidth: '65px',
          // width: '65px',
          height: BTN_HEIGHT,
          border: `1px solid ${brandColors.GREY_DARK} !important`,
          fontSize: '.85rem',
          /* ───────── base colours ───────── */
          backgroundColor: selected === 'AHU' ? brandColors.BLUE : brandColors.GREY_LIGHT,
          color: selected === 'AHU' ? '#fff !important' : brandColors.BLACK,

          /* ───────── hover / focus / active ───────── */

          '&:hover': {
            backgroundColor: selected === 'AHU' ? brandColors.BLUE : 'grey.300',
            boxShadow: '0px 0px 5px 0px #000000',
            color: selected === 'AHU' ? '#fff !important' : brandColors.BLACK,
            scale: '1.05',
          },
          '&:focus, &:active, &.Mui-focusVisible': {
            color: selected === 'AHU' ? '#fff !important' : brandColors.BLACK, // keep the text white while the
          }, // button is pressed or focused

          /* optional: remove the grey ripple that can darken text briefly */
          // '& .MuiTouchRipple-child': { backgroundColor: 'transparent' },
        }}>
        AHU
      </Button>

      {/* --- MANUAL / right button (text) --- */}
      <Button
        onClick={() => handleSelect('FCU')}
        sx={{
          flex: 1,
          minWidth: '65px',
          maxWidth: '65px',
          height: BTN_HEIGHT,
          border: `1px solid ${brandColors.GREY_DARK} !important`,
          fontSize: '.85rem',
          /* ───────── base colours ───────── */
          backgroundColor: selected === 'FCU' ? brandColors.BLUE : brandColors.GREY_LIGHT,
          color: selected === 'FCU' ? '#fff !important' : brandColors.BLACK,

          /* ───────── hover / focus / active ───────── */

          '&:hover': {
            backgroundColor: selected === 'FCU' ? brandColors.BLUE : 'grey.300',
            boxShadow: '0px 0px 5px 0px #000000',
            color: selected === 'FCU' ? '#fff !important' : brandColors.BLACK,
            scale: '1.05',
          },
          '&:focus, &:active, &.Mui-focusVisible': {
            color: selected === 'FCU' ? '#fff !important' : brandColors.BLACK, // keep the text white while the
          }, // button is pressed or focused

          /* optional: remove the grey ripple that can darken text briefly */
          // '& .MuiTouchRipple-child': { backgroundColor: 'transparent' },
        }}>
        FCU
      </Button>
    </Stack>
  );
};

export default HvacUnitSelector;
